import { Observable } from '../lib/store';

/**
 * What the user has selected. Prompt commands like "reverse the selected clip" or "move
 * the selected object 50 pixels right" act on this explicit context and fail clearly when
 * nothing (or something stale) is selected. Cleared whenever a project is opened or closed.
 */
export interface Selection {
  /** Audio workspace. */
  sampleId: string | null;
  clipId: string | null;
  /** Scene editor (objects of the active scene). */
  objectIds: string[];
  layerId: string | null;
  characterId: string | null;
  imageId: string | null;
  /** Animation shown on the timeline (Phase 3B); must belong to the active scene. */
  animationId: string | null;
}

const EMPTY: Selection = { sampleId: null, clipId: null, objectIds: [], layerId: null, characterId: null, imageId: null, animationId: null };

export class SelectionStore extends Observable<Selection> {
  constructor() {
    super(EMPTY);
  }

  selectSample(sampleId: string | null): void {
    this.update({ sampleId });
  }

  selectClip(clipId: string | null): void {
    this.update({ clipId });
  }

  selectObjects(objectIds: readonly string[]): void {
    const current = this.get().objectIds;
    if (current.length === objectIds.length && current.every((id, i) => id === objectIds[i])) return;
    this.update({ objectIds: [...objectIds] });
  }

  selectLayer(layerId: string | null): void {
    this.update({ layerId });
  }

  selectCharacter(characterId: string | null): void {
    this.update({ characterId });
  }

  selectAnimation(animationId: string | null): void {
    if (this.get().animationId !== animationId) this.update({ animationId });
  }

  selectImage(imageId: string | null): void {
    this.update({ imageId });
  }

  clear(): void {
    this.set(EMPTY);
  }
}
